import React from 'react';

const ValueUpdateCard = (props) => {
  return (
    <>
      <div className='card-glass-mini h-100'>
        <div className='card-body p-3'>
          <div className='row'>
            <div className='col-8'>
              <div className='numbers'>
                <p className='text-sm mb-0 text-uppercase font-weight-bold text-muted'>
                  {props.Title}
                </p>
                <h5 className='font-weight-bolder text-white mb-0'>
                  {props.Count}
                </h5>
              </div>
            </div>
            <div className='col-4 text-end'>
              <div className='icon-shape-gold shadow text-center border-radius-md ms-auto'>
                {props.Icon}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ValueUpdateCard;
